<div class="footer-copyright">
  <p>
    All Content &copy; 2022 PureSpectrum&reg; Marketplace Inc. All Rights
    Reserved.
  </p>
</div>
